<template>
    <div class="row mcas">
        <div class="col-md-6 col-lg-4 main">
            <div class="row" id="odrea">
                <div class="col-12 m-record">
                    <div class="row nav-top auto">
                        <div class="col-2 xtl"><span class="nav-back wt" @click="$router.go(-1)"></span></div>
                        <div class="col-8 tfw-5 tf-18">Order</div>
                        <div class="col-2"></div>
                        <div class="col-12 pa-0 odtnav dflxsbt">
                            <div class="xtab" id="FastParity"
                                onclick="window.location.href='#/orderrecord?server=FastParity'">FastParity</div>
                            <div class="xtab" id="Parity" onclick="window.location.href='#/orderrecord?server=Parity'">
                                Parity</div>
                            <div class="xtab" id="Dice" onclick="window.location.href='#/orderrecord?server=Dice'">Dice
                            </div>
                            <div class="xtab" id="AndharBahar"
                                onclick="window.location.href='#/orderrecord?server=AndharBahar'">Andar Bahar</div>
                            <div class="xtab" id="Wheelocity"
                                onclick="window.location.href='#/orderrecord?server=Wheelocity'">Circle</div>
                            <div class="xtab" id="Crash" onclick="window.location.href='#/orderrecord?server=Crash'">JetX
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12" id="dtaod">
                            <div class="row tf-14 rbs mb-2 mt-2 myma" v-for="rows in betrec" :key="rows.id" :rowsrec="rows">
                                <div class="col-6 pb-2 tf-16 xtl">{{ rows.period }}</div>
                                <div class="col-6 pb-2 xtr">{{ gettime(rows.time) }}</div>
                                <div class="col-3 pb-2 xtl">Select</div>
                                <div class="col-2 pb-2">Point</div>
                                <div class="col-2 pb-2">Result</div>
                                <div class="col-5 pb-2 xtr">Amount</div>
                                <div class="col-3 xtl" v-html="mydec(rows.ans, rows.winpoint)"></div>
                                <div class="col-2">{{ rows.amount }}.00</div>
                                <div class="col-2" v-html="getele(rows.number, rows.fres, rows.status)">

                                </div>
                                <div class="col-5 xtr tf-20 tfw-6 tffm"
                                    v-html="betamount(rows.amount, rows.ans, rows.res, rows.color2,rows.status,rows.winpoint)">

                                </div>
                                <div class="col-12 pt-2">
                                    <div class="row pt-2 rbt1ps">
                                        <div class="col-6 xtl">Delivery: {{ deli(rows.amount, rows.ans) }}</div>
                                        <div class="col-6 xtr">Fee: {{ fee(rows.amount) }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" id="footer"></div>
            <div class="row" id="opffp">
            </div>
            <div class="row" id="anof">

            </div>
            <div class="row" id="dta_ref"></div>
        </div>
    </div>
</template>


<script>
import axios from "axios";
export default {
    name: "HomeView",
    data() {
        return {
            server: null,
            username: null,
            betrec: ''
        }

    },
    beforeCreate: function () {
        if (localStorage.getItem('username') == null) {
            this.$router.push({ name: 'login' });
        }
    },
    mounted: function () {
        this.server = this.$route.query.server;
        this.setserver();
        this.getrec();
    },
    watch: {
        $route() {
            this.server = this.$route.query.server;
            this.setserver();
            this.getrec();
        }
    },
    methods: {
        fee(am) { if (this.server == "Crash") { return 0 } else { return 2 / 100 * am } },
        setserver() {
            document.getElementById("FastParity").classList.remove('sel');
            document.getElementById("Parity").classList.remove('sel');
            document.getElementById("Dice").classList.remove('sel');
            document.getElementById("AndharBahar").classList.remove('sel');
            document.getElementById("Wheelocity").classList.remove('sel');
            document.getElementById("Crash").classList.remove('sel');
            document.getElementById(this.server).classList.add('sel');
        },
        getrec() {
            this.username = localStorage.getItem('username');
            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=betrec&user=' + this.username + '&server=' + this.server).then((res) => {
                this.betrec = res.data;
                console.log(this.betrec);
            }).catch((err) => {
                console.log(err);
            })
        },
        betamount(x, y, z, a, b,c) {
            if (this.server != 'Crash') {
                var amount;
                var f;
                if (z == "fail") {
                    f = 98 / 100 * x;
                    amount = "<r> -" + (f.toFixed(2)) + "</r>";
                    return amount;
                } else if (z == 'success') {
                    if (a == "violet") {
                        if (y == "green" || y == "red") {
                            f = 98 / 100 * x * 1.5;
                            amount = "<g>+" + f.toFixed(2) + "</g>";
                            return amount;
                        } else if (y == "violet") {
                            f = 98 / 100 * x * 3;
                            amount = "<g>+" + f.toFixed(2) + "</g>";
                            return amount;
                        } else {
                            f = 98 / 100 * x * 9;
                            amount = "<g>+" + f.toFixed(2) + "</g>";
                            return amount;
                        }
                    } else {
                        if (y == "green" || y == "red") {
                            f = 98 / 100 * x * 2;
                            amount = "<g>+" + f.toFixed(2) + "</g>";
                            return amount;
                        } else if (y == "violet") {
                            f = 98 / 100 * x * 1.5;
                            amount = "<g>+" + f.toFixed(2) + "</g>";
                            return amount;
                        } else {
                            f = 98 / 100 * x * 9;
                            amount = "<g>+" + f.toFixed(2) + "</g>";
                            return amount;
                        }
                    }

                } else {
                    return "<span class='icon wait'></span>";
                }
            } else {
                if(b=="success"){
                    f=x*c
                    amount = "<g>+" + f.toFixed(2) + "</g>";
                            return amount;
                }else{
                    f =parseFloat(x);
                    amount = "<r> -" + (f.toFixed(2)) + "</r>";
                    return amount;
                }
                
            }
        },

        gettime(time) {
            var timeStamp = Date.parse(time);
            const date = new Date(timeStamp);
            var dateFormat = date.getDate() +
                "/" + (date.getMonth() + 1) + " " + date.getHours() +
                ":" + date.getMinutes() + ":0" + date.getSeconds();
            return dateFormat;
        },
        getele(ele, a, st) {
            if (this.server == "FastParity" || this.server == "Parity") {
                if (ele % 2 == 1) {
                    if (ele == 5) {
                        return "<div class='GS'><div class='vil'></div><div class='tpr'>" + ele + "</div></div>"
                    } else {
                        return "<div class='GS'><div class=''></div><div class='tpr'>" + ele + "</div></div>"
                    }

                } else if (ele % 2 == 0) {
                    if (ele == 0) {
                        return "<div class='RS'><div class='vil'></div><div class='tpr'>" + ele + "</div></div>"
                    } else {
                        return "<div class='RS'><div class=''></div><div class='tpr'>" + ele + "</div></div>"
                    }
                } else {
                    return "<div class='' style='margin-left: 25%;'><span class='icon wait'></span></div>"
                }
            } else if (this.server == "Crash") {
                if (st == "success") {
                    return "<div class='GS'>" + st + "</div>"
                } else {
                    return "<div class='RS'>" + st + "</div>"
                }

            } else if (this.server == "Wheelocity") {
                if (a == "wait" || a == "") {
                    return "<div class='' style='margin-left: 25%;'><span class='icon wait'></span></div>"
                } else {
                    return "<div class='RS'><div class=''></div><div class='wlrcd wlb " + a + "'></div></div>"
                }

            } else if (this.server == "AndharBahar") {
                if (ele == "wait" || ele == "") {
                    return "<div class='' style='margin-left: 25%;'><span class='icon wait'></span></div>"
                } else {
                    return "<div class='RS'><div class=''></div><div class='tpr'>" + ele + "</div></div>"
                }

            }
            else if (this.server == "Dice") {
                if (ele == "wait" || ele == "") {
                    return "<div class='' style='margin-left: 25%;'><span class='icon wait'></span></div>"
                } else {
                    return "<div class='RS'><div class=''></div><div class='tpr'>" + ele + "</div></div>"
                }

            }


        },
        mydec(dec, win) {
            if (this.server != 'Crash') {
                if (dec == "red") {
                    return '<span class="RS grvrb">Red</span>'
                } else if (dec == "green") {
                    return '<span class="GS grvrb">Green</span>'
                } else if (dec == "violet") {
                    return '<span class="VS grvrb">Violet</span>'
                } else {
                    return '<span class="NS grvrb">' + dec + '</span>'
                }
            } else {
                return win;
            }

        },
        deli(amount, ans) {
            if(this.server=="Crash"){
                return amount;
            }else{
                if (ans == "red" || ans == "green") {
                return 98 / 100 * amount * 2;
            } else if (ans == "violet") {
                return 98 / 100 * amount * 1.5;
            } else {
                return 98 / 100 * amount * 9;
            }
            }
            
        },
        getcolor(stat) {
            if (stat == "red") {
                return 'RS';
            } else if (stat == "green") {
                return 'GS';
            }
        }


    }
}
</script>
